import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div\n  ...attributes\n  {{did-insert this.animate}}\n  data-test-autoplay={{if this.autoplay \'true\' \'false\'}}\n></div>")